import { CALENDAR_SELECTIONS_SESSION_STORAGE_KEY } from '../storeCalendarSelections/storeCalendarSelections';
export const extractCalendarSelections = _ref => {
  let {
    session
  } = _ref;
  const calendarSelections = session.getItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY);
  if (!calendarSelections) {
    return;
  }
  return JSON.parse(calendarSelections);
};
//# sourceMappingURL=extractCalendarSelections.js.map